require('!!raw-loader!/builds/823803/v2/src/index.html');